import union from 'lodash/union'
import * as types from '../constants/ActionTypes'

const updateUserReports = (state = {
		isFetching: false,
		pageCount: 0,
		endOfDoc: undefined,
		reports: []
	}, action) => {
	switch (action.type) {
		case types.REQUEST_USER_REPORTS:
			return {
				...state,
				isFetching: true
			}
		case types.RECEIVE_USER_REPORTS:
			return {
				...state,
				isFetching: false,
				reports: union(state.reports, action.payload.userReports[action.category]),
				endOfDoc: action.payload.userReports.endOfDoc,
				pageCount: state.pageCount + 1
			}
		default:
			return state
	}
}

const updateUserReportsCategory = (state = {}, action) => {
	switch (action.type) {
		case types.REQUEST_USER_REPORTS:
		case types.RECEIVE_USER_REPORTS:
			return {
				...state,
				[action.category]: updateUserReports(state[action.category], action)
			}
		default:
			return state
	}
}

const updateUserReportsByCategory = (state = {}, action) => {
	switch (action.type) {
		case types.REQUEST_USER_REPORTS:
		case types.RECEIVE_USER_REPORTS:
			return {
				...state,
				reportsByCategory: updateUserReportsCategory(state.reportsByCategory, action)
			}
		default:
			return state
	}
}

export default updateUserReportsByCategory


// WEBPACK FOOTER //
// ./src/reducers/paginateUserReports.js